module.exports = __webpack_public_path__ + "static/media/menu.9a39f553.svg";